import { queryOptions } from '@tanstack/react-query'
import queryString from 'query-string'

import { apiClient, fetchIngredients } from '.'
import { FoodGroup, FoodRestriction, Ingredient, SearchIngredient } from './types'

async function fetchFoodGroups(): Promise<FoodGroup[]> {
  return apiClient.get('/foodgroup/').then((res) => res.data)
}

export const foodGroupsQuery = queryOptions({
  queryKey: ['foodgroups'],
  queryFn: fetchFoodGroups,
})

async function fetchFoodGroup(idGroup: string): Promise<FoodGroup> {
  return apiClient.get(`/foodgroup/${idGroup}`).then((res) => res.data)
}

export const foodGroupQuery = (idGroup: string) =>
  queryOptions({
    queryKey: ['foodgroups', idGroup],
    queryFn: () => fetchFoodGroup(idGroup),
  })

export const foodGroupIngredientsQuery = (idGroup: string) =>
  queryOptions({
    queryKey: ['foodGroupsIng', idGroup],
    queryFn: () => fetchIngredients({ idGroup: parseInt(idGroup) }),
  })

export async function saveFoodGroup(foodGroup: FoodGroup) {
  return apiClient.post('/foodgroup/', foodGroup).then((res) => res.data)
}

export async function deleteFoodGroup(idGroup: number) {
  return apiClient.delete(`/foodgroup/${idGroup}`).then((res) => res.data)
}

export async function addIngredientsToFoodGroup(
  foodGroup: FoodGroup,
  ingredients: SearchIngredient[],
) {
  const ids = ingredients.map((i) => i.idIngredient)

  return apiClient.post(`/foodgroup/${foodGroup.idGroup}/ingredient`, null, {
    params: {
      idIngredient: ids,
    },
    paramsSerializer: (params) => {
      return queryString.stringify(params)
    },
  })
}

export async function removeIngredientFromFoodGroup(idGroup: number, idIngredient: number) {
  return apiClient.delete(`/foodgroup/${idGroup}/ingredient`, {
    params: {
      idIngredient: idIngredient,
    },
  })
}

export async function addIngredientsToFoodRestriction(
  foodRestriction: FoodRestriction,
  ingredients: SearchIngredient[],
) {
  const ids = ingredients.map((i) => i.idIngredient)

  return apiClient.post(
    `/food-restrictions/${foodRestriction.idFoodRestriction}/ingredient`,
    null,
    {
      params: {
        idIngredient: ids,
      },
      paramsSerializer: (params) => {
        return queryString.stringify(params)
      },
    },
  )
}

export async function removeIngredientFromFoodRestriction(
  foodRestriction: FoodRestriction,
  ingredient: Ingredient,
) {
  return apiClient.delete(`/food-restrictions/${foodRestriction.idFoodRestriction}/ingredient`, {
    params: {
      idIngredient: ingredient.idIngredient,
    },
  })
}
